import { render, staticRenderFns } from "./CartGroups.vue?vue&type=template&id=d252b4f8&"
import script from "./CartGroups.vue?vue&type=script&lang=js&"
export * from "./CartGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports